import { useEffect, useState } from 'react';
import api from '../../utils/api';
import { getErrorMessage } from '../../utils/errorMessage';

export default function useCanvasScriptPrecheck(source, preview) {
  const signature = source ? JSON.stringify(source) : '';
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!signature || preview) { setState(null); return undefined; }
    const controller = new AbortController();
    setState(null);
    const timer = setTimeout(async () => {
      try {
        const { data } = await api.post('/canvas/script-import/precheck', { source: JSON.parse(signature) }, { signal: controller.signal, timeout: 20000 });
        if (!Array.isArray(data?.checks) || !data.checks.length || typeof data.passed !== 'boolean') throw new Error('未能读取预检查结果，请重试。');
        if (!controller.signal.aborted) setState({ signature, result: data });
      } catch (error) {
        if (!controller.signal.aborted) setState({ signature, error: getErrorMessage(error, '剧本预检查失败，请重试。') });
      }
    }, 450);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [signature, preview, attempt]);
  // Never use a successful response for a different episode or an edited draft.
  const current = state?.signature === signature ? state : null;
  return {
    result: current?.result, error: current?.error,
    checking: Boolean(signature && !preview && !current),
    passed: Boolean(signature && !preview && current?.result?.passed && current.result.checks.every(check => check.passed === true)),
    retry: () => { setState(null); setAttempt(value => value + 1); },
    reject: result => setState({ signature, result }),
  };
}
